<template>
	<div class="news">
		<div class="news_from" style="margin-top: 100px">
			<div>资讯类型：</div>
			<div class="news_Location">
				<div class="news_Location_item" v-for="(item, index) in news_kind" :key="index"
					@click="handClick(item.id)" :style="(tabIndex == item.id ? 'color:rgb(26, 127, 221)' : '')">
					<img v-if="item.id === 4" src="../../static/other/icon-fee.png" class="img-icon-fee" />
					<img v-else-if="item.id === 6" class="icon-standard" src="../../static/other/icon-standard.png" />
					<span>{{ item.kind }}</span>
				</div>
			</div>
		</div>
		<!-- <div class="news_from">
      <div>新闻属地：</div>
      <div class="news_Location">
        <div class="news_Location_item" v-for="(item,index) in province" :key="index">{{item}}</div>
      </div>
    </div> -->
		<!--收费标准-->
		<div class="standard_con" v-if="tabIndex === 6">
			<table>
				<tr>
					<th>类型</th>
					<th>收费标准</th>
					<th>图标</th>
				</tr>
				<tr>
					<td>收费</td>
					<td>￥5/条</td>
					<td><img src="../../static/other/icon-fee.png" class="icon-fee" /></td>
				</tr>
				<tr>
					<td>免费</td>
					<td>免费</td>
					<td><img src="../../static/other/icon-free.png" class="icon-free" /></td>
				</tr>
			</table>
			<h2>图标说明：</h2>
			<p><img src="../../static/other/icon-fee.png" class="icon-fee" /> <span>：表示该内容需要支付5元人民币后方可阅读。</span></p>
			<p><img src="../../static/other/icon-free.png" class="icon-free" /><span>：表示该内容可以免费阅读，无需支付任何费用。</span></p>
			<h2>收费标准细节：</h2>
			<p><span>收费内容：</span>用户支付5元后，即可阅读相应的内容。使用付费时提供的手机号，通过验证码登录后，可以享受无限次重复阅读的权益。</p>
			<p><span>免费内容：</span>用户无需支付任何费用，即可直接阅读。</p>
			<h2>备注：</h2>
			<p>收费标准可能会根据内容的更新和市场情况进行调整，具体以实际展示为准。</p>
			<p>我们承诺将持续优化内容质量和服务体验，以满足用户的多元化需求。</p>
			<p>感谢您的理解与支持，我们期待为您提供优质的内容服务！</p>
		</div>
		<div class="news_con" v-else v-loading="loading">
			<div v-for="(item, index) in newList" class="news_con_item" :key="index"
				@click="clickArticle(item, tabIndex)">
				<div class="news_con_time">
					<div>{{ dateFormat(item.publishedTime) }}</div>
				</div>
				<div class="news_text">
					<div class="news_title">
						<!--干货分享：收费优化-->
						<el-tooltip class="item" effect="dark" content="付费阅读" placement="top"
							v-if="tabIndex === 4">
							<img src="../../static/other/icon-fee.png" class="img-icon-fee" />
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="免费阅读" placement="top" v-else>
							<img src="../../static/other/icon-free.png" class="img-icon-free" />
						</el-tooltip>
						<span>{{ item.title }}</span>
					</div>
					<div class="news_detail">{{ item.summary }}</div>
				</div>
			</div>
			<div v-if='newList.length == 0' style="text-align: center;color:#999;">暂无数据</div>
		</div>
		<!-- 手机验证码验证弹窗 -->
		<PhoneCodeYz :visible.sync="loginVisible" v-if="loginVisible" :itemId="itemId" @success="phoneLoginCallback" />
		<!-- 二维码支付弹窗 -->
		<QrcodePay :visible.sync="qrcodeVisible" v-if="qrcodeVisible" :itemId="itemId" :payNo="payNo"
			@close="qrcodePayCallback" />
	</div>
</template>

<script>
import {
	checkPay
} from "@/api/basic";
import { getNews } from '@/api/news'
import axios from "axios";
import PhoneCodeYz from "./components/PhoneCodeYz";
import QrcodePay from "./components/QrcodePay";
import { encrypt } from "@/utils/crypto";
export default {
	name: "News",
	mixins: [],
	components: {
		PhoneCodeYz,
		QrcodePay
	},
	props: {},
	data() {
		return {
			loading: false,
			tabIndex: 1,
			province: [
				"北京",
				"上海",
				"内蒙古",
				"广西",
				"黑龙江",
				"江苏",
				"新疆",
				"四川",
				"云南",
			],
			news_kind: [
				// 公司动态
				{
					id: 1,
					key: 'company_news',
					kind: "公司动态",
					list: [],
				},
				// 政策解读
				{
					id: 2,
					key: 'policy',
					kind: "政策解读",
					list: [],
				},
				// 行业资讯
				{
					id: 3,
					key: 'industry',
					kind: "行业资讯",
					list: [],
				},
				// 干货分享
				// {
				// 	id: 4,
				// 	key: 'dry_goods_sharing',
				// 	kind: "干货分享",
				// 	list: [],
				// },
				// 时事热点
				{
					id: 5,
					key: 'hot_news',
					kind: "时事热点",
					list: [],
				},
			],
			news: [],
			itemId: null, // 文章id
			payNo: null, // 微信支付付款单号
			qrcodeVisible: false,
			qrcodeUrl: "",
			loginVisible: false,
			timer: null,
			// json文件和id的对应管
			map: {
				'1': 'company-news.json', // 公司动态
				'2': 'policy-news.json', // 政策解读
				'3': 'industry-news.json', // 行业资讯
				'4': 'knowledge-news.json', // 干货分享
				'5': 'hotspot-news.json', // 时事热点
			},
			newList: [] // news_kind[tabIndex-1]['list']
		};
	},
	computed: {},
	watch: {
		$route: {
			handler: function (val) {
				this.tabIndex = val.query.tabIndex;
				this.loadNews()
			},
			// 深度观察监听
			deep: true,
		},
	},
	methods: {
		async handClick(tabIndex) {
			this.tabIndex = tabIndex
			await this.loadNews()
		},
		// 加载新闻
		async loadNews() {
			// const tabIndex = this.tabIndex + ''
			// let res = await axios.get(`https://dhtest-guanwang.dinghanwang.com/news/${this.map[tabIndex]}`)
			// this.newList = res.data || []
			this.loading = true
			console.log(this.tabIndex)
			// const activeItem = this.news_kind[this.tabIndex - 1]
			const activeItem = this.news_kind.find(i => i.id == this.tabIndex)||{}
			let res = await getNews({
				categoryCode: activeItem.key
			}).finally(() => {
				this.loading = false
			})
			this.newList = res.rows || []
		},
		clickArticle(item, id) {
			if (id === 4) {
				// 验证文章权限
				this.validArticle(item.id, item.link)
			} else {
				clearInterval(this.timer)
				this.goArticle(item.id)
			}
		},
		async validArticle(id, link) {
			const phone = sessionStorage.getItem("phone");
			if (phone) {
				const res = await this.checkPay(id)
				if (res.data.resultCode == '200') {
					const {
						payNo,
						status
					} = res.data.data // status：0-未交费，1-已缴费
					if (status == 1) this.goArticle(id)
					else {
						this.payNo = payNo
						this.goPay(id, link)
					}
				} else {
					this.$message.error(res.data.repMsg)
				}
			} else {
				this.loginVisible = true
				this.itemId = id
			}
		},
		// 打开二维码付款
		goPay(id, link) {
			clearInterval(this.timer)
			this.qrcodeVisible = true
			this.itemId = id
			this.loopCheckPay(id, link)
		},
		goArticle(id) {
			let phone = '' 
			const itemIndex = this.news_kind.find(i => i.id == this.tabIndex)||{}
			if(itemIndex.key == 'dry_goods_sharing') {
				// 付费新闻携带手机参数加密
				phone = sessionStorage.getItem("phone")
			}
			
			const query = phone ? { p: encrypt(phone) } : {}
			const routeUrl = this.$router.resolve({
				path: `/news/view/${id}`,
				query
			});
			window.open(routeUrl.href, '_blank');
		},
		getArticleUrl(id) {
			// let  url = 'https://dinghanwang.com/info/archives/'+id
			// return 'https://news.dinghanwang.com/archives/' + id
			return `/news/view/${id}`
		},
		// 短信验证码成功回调
		phoneLoginCallback(id) {
			this.loginVisible = false
			this.validArticle(id)
		},
		// 付款弹窗关闭回调
		qrcodePayCallback() {
			this.qrcodeVisible = false
		},
		// 轮询检查付款状态
		loopCheckPay(id, link) {
			this.timer = setInterval(async () => {
				let res = await this.checkPay(id)
				const {
					status
				} = res.data.data // status：0-未交费，1-已缴费
				if (status == 1) {
					this.$message.success('付款成功')
					this.qrcodeVisible = false
					clearInterval(this.timer)
					setTimeout(() => {
						this.goArticle(id)
					}, 1000);
				}
			}, 5000);
		},
		// 验证是否付费
		async checkPay(id) {
			const params = {
				phone: sessionStorage.getItem("phone"),
				url: this.getArticleUrl(id)
			}
			const ret = await checkPay(params)
			return ret
		},
		// 处理日期显示
		dateFormat(date) {
			if(!date) return '' 
			return date.substring(0, 10)
		},
	},
	created() {
		this.tabIndex = this.$route.query.tabIndex || 1;
		this.loadNews()
		clearInterval(this.timer)
	},
	beforeDestroy() {
		clearInterval(this.timer)
	},
};
</script>

<style scoped>
.news {
	width: 1200px;
	margin: auto;
}

.news_from {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 20px;
}

.news_Location {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	margin-left: 100px;
}

.news_Location_item {
	margin-right: 15px;
	color: #000;
	cursor: pointer;
	display: flex;
	align-items: center;
}

.news_Location_item img {
	height: 22px;
	margin-right: 3px;
}

.news_Location_item .icon-standard {
	height: 26px;
}

.news_con {
	margin: 50px 0;
	min-height: 40vh;
}

.news_con_item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 30px;
	cursor: pointer;
}

.news_con_time {
	margin-right: 30px;
	flex: 0 0 90px;
}

.news_detail {
	max-height: 52px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	/* 显示的行数 */
	-webkit-box-orient: vertical;
}

.news_title {
	font-weight: 600;
	display: flex;
	align-items: center;
}

.news_title img {
	height: 22px;
	margin-right: 5px;
}

.news_text:hover {
	color: rgb(26, 127, 221);
}

.standard_con {
	margin: 50px 0 50px 165px;
	font-size: 16px;
}

.standard_con table {
	width: 500px;
	border-collapse: collapse;
	margin: 20px 0;
}

.standard_con th,
.standard_con td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

.standard_con th {
	background-color: #f2f2f2;
}

.standard_con img {
	height: 22px;
}

.standard_con h2 {
	font-weight: bold;
	margin-bottom: 10px;
	margin-top: 15px;
}

.standard_con p {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
</style>
